import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = { display: "flex", flexDirection: "column", gap: 0.5 };
export const title: SxProps<Theme> = { fontWeight: 700, fontSize: { xs: "0.90625rem", md: "1rem" } };
export const subtitle: SxProps<Theme> = { fontSize: { xs: "0.71875rem", md: "0.78125rem" }, color: "text.secondary", lineHeight: 1.7 };
export const mobileOnly: SxProps<Theme> = { display: { xs: "inline", md: "none" } };
export const desktopOnly: SxProps<Theme> = { display: { xs: "none", md: "inline" } };
